/**
 * Web 环境不启用 Reactotron
 */
export class Environment {
  constructor() {}

  async setup() {}

  reactotron: undefined
}
